import { useEffect, useState } from "react";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import Lock from "../../Components/Lock";
import { GET_MONTH_YEAR } from "../../Model/HomeModel";
import { convertTo12Hour } from "../../Model/ToastEditiorOption";
import { JoinClass } from "../../Action/AttendanceAction";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";

export default function MobileLiveClass({ batchDet, DemoClasses, classRecs }) {
  const [SideOpener, setSideOpner] = useState(false);
  const dispatch = useDispatch();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="Live class" OpenSideMenu={OpenSideMenu} />
          <div className="Live_class">
            {!batchDet && !DemoClasses?.length ? (
              <div style={{ padding: "20px" }}>
                <Lock />
              </div>
            ) : (
              <div className="content">
                {/* <!-- Section Header --> */}
                <div className="section-header">
                  <h2 className="section-title">Upcoming Online Classes</h2>
                  <p className="section-description">
                    Stay Ahead With Upcoming Online Classes—Learn New Concepts,
                    Sharpen Skills, And Reach Your Goals!
                  </p>
                </div>

                {/* <!-- Classes List --> */}
                <div className="classes-list">
                  {/* <!-- Class Card 1 --> */}
                  {classRecs?.map((el, i) => (
                    <div key={i + 904} className="class-card">
                      <div className="card-header">
                        <div className="class-info">
                          <h3 className="class-title"> {el?.ClassName}</h3>
                          <div className="instructor-info">
                            <img
                              src="/assets/image/user.svg"
                              alt={
                                el?.Batch_Id?.Faculty?.First_Name
                                  ? el?.Batch_Id?.Faculty?.First_Name +
                                    " " +
                                    el?.Batch_Id?.Faculty?.Last_Name
                                  : "N/A"
                              }
                              className="instructor-avatar"
                            />
                            <span className="instructor-name">
                              {el?.Batch_Id?.Faculty?.First_Name
                                ? el?.Batch_Id?.Faculty?.First_Name +
                                  " " +
                                  el?.Batch_Id?.Faculty?.Last_Name
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                        <span className="status-badge">
                          {el?.ClassType == 1 ? "Online" : "Offline"}
                        </span>
                      </div>

                      <div className="card-divider"></div>

                      <div className="datetime-section">
                        <div className="datetime-item">
                          <svg
                            className="datetime-icon"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <rect
                              x="3"
                              y="4"
                              width="18"
                              height="18"
                              rx="2"
                              ry="2"
                            ></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                          </svg>
                          <div className="datetime-content">
                            <span className="datetime-label">Date</span>
                            <span className="datetime-value">
                              {" "}
                              {el?.DateOfClass
                                ? GET_MONTH_YEAR(el?.DateOfClass)
                                : el?.ClassDate
                                ? GET_MONTH_YEAR(el?.ClassDate)
                                : ""}
                            </span>
                          </div>
                        </div>

                        <div className="datetime-item">
                          <svg
                            className="datetime-icon"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12,6 12,12 16,14"></polyline>
                          </svg>
                          <div className="datetime-content">
                            <span className="datetime-label">Time</span>
                            <span className="datetime-value">
                              {el?.ClassTimingFrom
                                ? convertTo12Hour(el?.ClassTimingFrom) +
                                  " - " +
                                  convertTo12Hour(el?.ClassTimingTo)
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      {el?.ClassType == 1 ? (
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                },
                                el?.ClassId
                              )
                            );
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                          className="join-button"
                        >
                          <span>Join Class</span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            <polyline points="15,3 21,3 21,9"></polyline>
                            <line x1="10" y1="14" x2="21" y2="3"></line>
                          </svg>
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                },
                                el?.ClassId
                              )
                            );
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                          className="join-button"
                        >
                          <span>Mark Attendance</span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            <polyline points="15,3 21,3 21,9"></polyline>
                            <line x1="10" y1="14" x2="21" y2="3"></line>
                          </svg>
                        </button>
                      )}
                    </div>
                  ))}

                  {/* <!-- Class Card 3 --> */}
                  {/* <div className="class-card">
                    <div className="card-header">
                      <div className="class-info">
                        <h3 className="class-title">OET Batch Classes</h3>
                        <div className="instructor-info">
                          <img
                            src="https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=200&h=200&dpr=2"
                            alt="Disha Malviya"
                            className="instructor-avatar"
                          />
                          <span className="instructor-name">Disha Malviya</span>
                        </div>
                      </div>
                      <span className="status-badge">Online</span>
                    </div>

                    <div className="card-divider"></div>

                    <div className="datetime-section">
                      <div className="datetime-item">
                        <svg
                          className="datetime-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <div className="datetime-content">
                          <span className="datetime-label">Date</span>
                          <span className="datetime-value">30 June 2025</span>
                        </div>
                      </div>

                      <div className="datetime-item">
                        <svg
                          className="datetime-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12,6 12,12 16,14"></polyline>
                        </svg>
                        <div className="datetime-content">
                          <span className="datetime-label">Time</span>
                          <span className="datetime-value">
                            10:00 AM - 12:00 PM
                          </span>
                        </div>
                      </div>
                    </div>

                    <button className="join-button">
                      <span>Link</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1-2-2h6"></path>
                        <polyline points="15,3 21,3 21,9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </button>
                  </div> */}
                </div>
              </div>
            )}
          </div>
          <MobileBottomMenu Page="LiveClass" />
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
